import { Outlet } from 'react-router-dom';
import { TopNav, BottomNav } from './Navigation';
import { NotificationBell } from '../../features/NotificationBell';

export function AppShell() {
  return (
    <div className="min-h-screen bg-pearl dark:bg-dark-bg transition-colors duration-300">
      <NotificationBell />
      <TopNav />
      <main className="max-w-7xl mx-auto px-4 py-6 pb-24 md:pb-6">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
